import type { ImageName } from '../types';

export const imagePaths: Record<ImageName, string> = {
  '400-error-bad-request': '/assets/images/400-error-bad-request.svg',
  '401-error-unauthorized': '/assets/images/401-error-unauthorized.svg',
  '403-error-forbidden': '/assets/images/403-error-forbidden.svg',
  '404-error-with-a-landscape': '/assets/images/404-error-with-a-landscape.svg',
  '500-internal-server-error': '/assets/images/500-internal-server-error.svg',
  acces: '/assets/images/acces.svg',
  'app-monetization': '/assets/images/app-monetization.svg',
  'application-end': '/assets/images/application-end.svg',
  'application-succes': '/assets/images/application-succes.svg',
  'choice-chat': '/assets/images/choice-chat.svg',
  close: '/assets/images/close.svg',
  'cyber-attack': '/assets/images/cyber-attack.svg',
  documents: '/assets/images/documents.svg',
  'dont-work': '/assets/images/dont-work.svg',
  fly: '/assets/images/fly.svg',
  'folder-bro': '/assets/images/folder-bro.svg',
  'forgot-password-bro-3': '/assets/images/forgot-password-bro-3.svg',
  mailbox: '/assets/images/mailbox.svg',
  money: '/assets/images/money.svg',
  'new-chat': '/assets/images/new-chat.svg',
  pdf: '/assets/images/pdf.svg',
  profiling: '/assets/images/profiling.svg',
  'resume-folder': '/assets/images/resume-folder.svg',
  'search-engines': '/assets/images/search-engines.svg',
  'select-provider': '/assets/images/select-provider.svg',
  'signing-a-contract': '/assets/images/signing-a-contract.svg',
  spinner: '/assets/images/spinner.svg',
  succes: '/assets/images/succes.svg',
  table: '/assets/images/table.svg',
  'team-checklist-bro': '/assets/images/team-checklist-bro.svg',
  'version-control': '/assets/images/version-control.svg',
};
